import type { RecipeIngredient } from '@/types/recipe';
import type { PendingIngredientSubstitutionAction } from '@/types/chat';

/** Ingredient reference for the substitution question, e.g. "2 tbsp olive oil". */
export function formatIngredientRef(
  ing: Pick<RecipeIngredient, 'quantity' | 'unit' | 'name'>,
): string {
  const qtyPart = [ing.quantity, ing.unit].filter(Boolean).join(' ');
  return qtyPart ? `${qtyPart} ${ing.name}` : ing.name;
}

export function buildSubstitutionMessage(ingredientRef: string): string {
  return `I don't have ${ingredientRef} — what can I substitute it with?`;
}

// Built here, not in ChatContext, so the generic provider stays unaware of the domain.
export function makeSubstitutionAction(ingredientRef: string): PendingIngredientSubstitutionAction {
  return { type: 'ingredient_substitution', autoSendMessage: buildSubstitutionMessage(ingredientRef) };
}
